// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import messages from '../../locale/jsonMessages';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Grid, Button, Row, Col } from 'react-bootstrap';

import Loader from '../../components/Loader';
import WishListGroupItem from './WishListGroupItem';
import WishListGroupModal from './WishListGroupModal';

import { openAddWishListGroupModal } from '../../actions/WishList/modalActions';
import { getAllWishListGroupQuery } from '../../lib/graphql';
import addIcon from '/public/siteImages/addIcon.svg';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './WishLists.css';

function WishListComponent(props) {
    const { data: { loading, getAllWishListGroup }, profileId } = props;
    const { openAddWishListGroupModal } = props;

    const openAddWishListModal = () => {
        openAddWishListGroupModal({}, 'AddWishListGroupForm')
        var root = document.getElementsByTagName('html')[0];
        root.classList.add('scrollHidden');
    }

    return (
        <div>
            <WishListGroupModal actionType={'add'} />
            <Grid fluid className={cs.commonContainerList}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={cx(cs.dFlexContainer, cs.flexWrap)}>
                            <h2 className={cx(cs.commonTitleText, cs.fontWeightBold, cs.paddingBottom5)}>
                                <FormattedMessage {...messages.wishLists} />{' '}
                                {
                                    getAllWishListGroup?.count > 0 && getAllWishListGroup.wishListGroupData && getAllWishListGroup.wishListGroupData.length > 0 && <>
                                        <span className={cs.displayinlineBlock}>
                                            ({getAllWishListGroup.count})
                                        </span>
                                    </>
                                }
                            </h2>
                            <Button className={cx(cs.btnPrimary, cs.spaceBottom5, cs.dFlex)} onClick={openAddWishListModal}>
                                <img src={addIcon} className={cx('commonIconSpace', s.createIcon)} />
                                <FormattedMessage {...messages.createWishList} />
                            </Button>
                        </div>
                        {
                            loading && <>
                                <Loader type="text" />
                            </>
                        }
                        {
                            !loading && getAllWishListGroup && getAllWishListGroup.status == 'success' && <>
                                {
                                    getAllWishListGroup.wishListGroupData && getAllWishListGroup.wishListGroupData.length > 0 && getAllWishListGroup.count > 0 && <Row className={s.flexColumn}>
                                        {
                                            getAllWishListGroup.wishListGroupData.map((item, index) => {
                                                return (
                                                    <Col xs={12} sm={4} md={3} lg={3} key={index} className={cs.spaceBottom6}>
                                                        <WishListGroupItem data={item} />
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                }
                                {
                                    getAllWishListGroup.wishListGroupData && getAllWishListGroup.wishListGroupData.length == 0 && getAllWishListGroup.count == 0 && <>
                                        <h5 className={cx(cs.commonTotalText, cs.fontWeightMedium)}>
                                            <FormattedMessage {...messages.noWishlists} />
                                        </h5>
                                    </>
                                }
                            </>
                        }
                    </Col>
                </Row>
            </Grid>
        </div>
    )
}

WishListComponent.propTypes = {
    profileId: PropTypes.number.isRequired,
    openAddWishListGroupModal: PropTypes.func.isRequired
};

WishListComponent.defaultProps = {
    profileId: 0
};

const mapState = (state) => ({
});

const mapDispatch = {
    openAddWishListGroupModal
};

export default compose(
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withQuery(getAllWishListGroupQuery,
        {
            options: (props) => ({
                variables: {
                    profileId: props.profileId
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(WishListComponent);